// Types
import { FETCH_SUBMISSION } from "constants/types";

// Helpers
import { apiRequest } from "helpers/apiClient";

export const fetchSubmission = (guid) => (dispatch) => {
    return apiRequest(`/api/v1/Innsending/${guid}`, {
        headers: { Accept: "application/hal+json" }
    }).then((result) => {
        if (result.ok) {
            const form = result.data;
            dispatch({ type: FETCH_SUBMISSION, payload: form });
            return form;
        }
        return {
            status: result.status,
            xCorrelationId: result.xCorrelationId
        };
    });
};
